import createHasSubmitFailed from './selectors/hasSubmitFailed';
import plain from './structure/plain';

export default createHasSubmitFailed(plain);


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form/es/hasSubmitFailed.js
// module id = 551
// module chunks = 0